import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const {
    login,
    isLoading
  } = useAuth();
  const navigate = useNavigate();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Default to Admin role for all users since role selection is removed
    login(email, 'Admin');
    navigate('/');
  };
  return <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4" data-id="element-212">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-213">
        {/* Header */}
        <div className="bg-emerald-700 p-8 text-center" data-id="element-214">
          <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mx-auto mb-4 backdrop-blur-sm" data-id="element-215">
            <span className="text-3xl font-bold text-white" data-id="element-216">L</span>
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-217">LISF Portal</h1>
          <p className="text-emerald-100 mt-2" data-id="element-218">
            Land Information and Service Framework
          </p>
        </div>

        {/* Form */}
        <div className="p-8" data-id="element-219">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-220">
            <Input label="Email Address" type="email" placeholder="admin@land.gov.bd" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-221" />

            <Input label="Password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-222" />

            <div className="flex items-center justify-between text-sm" data-id="element-223">
              <label className="flex items-center text-slate-600" data-id="element-224">
                <input type="checkbox" className="mr-2 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500" data-id="element-225" />
                Remember me
              </label>
              <a href="#" className="text-emerald-600 hover:text-emerald-700 font-medium" data-id="element-226">
                Forgot password?
              </a>
            </div>

            <Button type="submit" className="w-full bg-emerald-700 hover:bg-emerald-800" size="lg" isLoading={isLoading} data-id="element-227">
              Sign In to Dashboard
            </Button>
          </form>

          <div className="mt-6 text-center text-xs text-slate-400" data-id="element-228">
            &copy; 2024 Ministry of Land, Bangladesh. All rights reserved.
          </div>
        </div>
      </div>
    </div>;
}